var InboxMsgBonus = {
    VOUCHER: 1,
    BONUS: 2,
}

export {InboxMsgBonus}
